import React, { useEffect, useState } from "react";

import ProductPromotion from "theme/components/contentBlocks/ProductPromotion";
import PropTypes from "prop-types";
import transformFlexibleBackground from "theme/libs/wordpress/utils/transformFlexibleBackground";
import useAboveBreakpoint from "core-web/hooks/useAboveBreakpoint";

const ProductPromotionBlock = ({ content, mediaQuery, isFullWidth = false, isThreeColumn = false }) => {
    const { product, background: backgroundObject } = content;

    // Transform background data
    const transformedBackground = transformFlexibleBackground(backgroundObject);
    const mobileBackground = transformedBackground.mobile || transformedBackground.desktop;
    const desktopBackground = transformedBackground.desktop || transformedBackground.mobile;

    const isDesktop = useAboveBreakpoint("tabletSm");
    // const device = isDesktop ? "desktop" : "mobile";

    // Save background data
    const [background, setBackground] = useState(isDesktop ? desktopBackground : mobileBackground);

    // Update background and video object depending on device
    useEffect(() => {
        setBackground(isDesktop ? desktopBackground : mobileBackground);
    }, [isDesktop]);

    // Logic for image and mediaQueries
    // Default is optimized for a image with 100vw
    const fullWidthQueries = {
        w: [540, 740, 992, 1200, 1500, 1880, 2400, 2600],
        q: 70,
    };
    const finalQueries = mediaQuery ?? fullWidthQueries;

    const preparedData = {
        background,
        backgroundType: background?.type,
        product,
        mediaQuery: finalQueries,
        isFullWidth,
        isThreeColumn,
    };

    return <ProductPromotion {...preparedData} />;
};

ProductPromotionBlock.propTypes = {
    content: PropTypes.object,
};

ProductPromotionBlock.defaultProps = {
    content: {},
};

export default ProductPromotionBlock;
